import React from 'react';
import { CopyToClipboardButton } from '../../../../components/CopyToClipboardButton';
import { Field, FieldGrid, SectionCard } from '../../../../components/Section';
import { IAlpacaJournal } from '../../../../types/alpaca';
import { round2Format } from '../../../../utils/number';

interface AlpacaJournalProps {
  alpacaJournal: IAlpacaJournal;
}

export function AlpacaJournal({ alpacaJournal }: AlpacaJournalProps) {
  return (
    <SectionCard title="Journal" sx={{ mt: '16px' }}>
      <FieldGrid columns={3}>
        <Field label="Id">
          <CopyToClipboardButton text={alpacaJournal.journalId} value={alpacaJournal.journalId} />
        </Field>
        <Field label="Status" value={alpacaJournal.status} />
        <Field label="Type" value={alpacaJournal.type} />
        <Field label="Amount" value={round2Format(alpacaJournal.amount)} />
        <Field label="Original amount" value={round2Format(alpacaJournal.originalAmount)} />
        <Field label="Actual amount" value={round2Format(alpacaJournal.actualAmount)} />
        <Field label="Journal FX rate" value={alpacaJournal.fxRate} />
      </FieldGrid>
    </SectionCard>
  );
}
